__turbopack_context__.v({
  "button": "B2bFormButton-module-scss-module__rFVh4G__button",
  "focus-visible": "B2bFormButton-module-scss-module__rFVh4G__focus-visible",
  "modal": "B2bFormButton-module-scss-module__rFVh4G__modal",
  "modalContent": "B2bFormButton-module-scss-module__rFVh4G__modalContent",
});
